import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk to fetch dispensation logs
export const fetchDispensationLogs = createAsyncThunk(
  'dispensation/fetchDispensationLogs',
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetch('/api/v1/dispensed_prescriptions');
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Failed to fetch dispensation logs');
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const dispensationSlice = createSlice({
  name: 'dispensation',
  initialState: {
    logs: [],
    loading: false,
    loaded: false,
    error: null,
  },
  reducers: {
    clearDispensationLogs(state) {
      state.logs = [];
      state.error = null;
    },
     addLog(state, action) {
    state.logs = [action.payload, ...state.logs];
  },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDispensationLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDispensationLogs.fulfilled, (state, action) => {
         state.logs = action.payload.map(log => ({ ...log, key: log.id })); 
         state.loading = false;
         state.loaded = true;
      })
      .addCase(fetchDispensationLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearDispensationLogs, addLog} = dispensationSlice.actions;
export default dispensationSlice.reducer;
